import { Duration as DurationIcon } from '@shared/assets';
import * as st from './styles.module.scss';

interface Props {
  duration: string | number;
}

export const Duration = ({ duration }: Props) => {
  return (
    <div className={st.duration}>
      <DurationIcon />
      <span>{duration}</span>
    </div>
  );
};
